<template>
  <div id="app" class="main">
    <div class="lotteryBox" >
      <li v-for='(item,key) in lotteryData' :key="item.id" :class="key === index?'active':''">
        <img :src="item.imgUrl" alt="">
        <p>{{item.text}}</p>
      </li>
    </div>
    <div class="lotteryBtn">
      <van-button @click='lotteryBtn'>立即抽奖</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      lotteryData:[
        {id:0,imgUrl:require('../assets/activitiesimg/currency.png'),text:"10元"},
        {id:1,imgUrl:require('../assets/activitiesimg/currency.png'),text:"11元"},
        {id:2,imgUrl:require('../assets/activitiesimg/currency.png'),text:"10元"},
        {id:3,imgUrl:require('../assets/activitiesimg/currency.png'),text:"13元"},
        {id:4,imgUrl:require('../assets/activitiesimg/currency.png'),text:"111元"},
        {id:5,imgUrl:require('../assets/activitiesimg/currency.png'),text:"19元"},
        {id:6,imgUrl:require('../assets/activitiesimg/currency.png'),text:"310元"},
        {id:7,imgUrl:require('../assets/activitiesimg/currency.png'),text:"14元"},
        {id:8,imgUrl:require('../assets/activitiesimg/currency.png'),text:"1元"},
      ],
      index:-1,   //滚动下标
      times:1,    //滚动次数（每一个方格为一次）
      cycle:50,   //循环滚动的次数
      speed:200,  //转动速度
    }
  },
  methods: {
    lotteryBtn(){
      console.log('点击')
      this.startRoll();
      this.index = -1;
      this.speed = 200;
      this.times = 1;
    },
    roll(){
      var index = this.index;
      var count = this.lotteryData.length;  //总长度
      index += 1;
      if(index > count -1){
        index = 0
      }
      this.index = index
    },
    startRoll(){
      this.roll();
      this.times += 1;
      if(this.times > this.cycle + 20){
        clearTimeout(timer);  //清除延迟函数
        this.times = 0;
      }else{
        if(this.times < this.cycle+20){
          this.speed -=10;    //加快转动速度
        }else if(this.times >= this.cycle){
          this.speed += 20;
          var ind = 3
          // var ind = parseInt(Math.random()*8,0) || 0;    // 随机产生一个中奖号码
          console.log(ind)
          this.index = ind
        }
        var timer = setTimeout(this.startRoll,this.speed)
      } 
    }
  }
}
</script>

<style lang="scss">
.main {
  width: 300px;
  margin: 0 auto;
}
.lotteryBox {
  width: 300px;
  height: 300px;
  background: #AE1616;
  li {
    width: 90px;
    height: 90px;
    background: #fff;
    margin: 5px 0 5px 7px;
    float: left;
    font-size: 0;
    border-radius: 10px;
    img {
      margin-top: 10px;
      width: 50px;
      height: 50px;
    }
    p {
      padding-top: 10px;
      font-size: 12px;
    }
  }
  .active {
    background: #FFF2B1;
  }
}
.lotteryBtn {
  margin-top: 10px;
  width: 100%;
  font-size: 0;
}
.button {
  width: 100px;
  height: 20px;
  line-height: 20px;
  font-size: 12px;
  color: #fff;
  background: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
